var diceD = require('./../distances/dice');

module.exports = function dice(a, b) {
    return 1 - diceD(a,b);
};



// WEBPACK FOOTER //
// ./node_modules/ml-distance/src/similarities/dice.js